import React, { ReactNode } from 'react';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import './outlined-card.scss';

export interface IOutlinedCard extends IComponent {
  footer?: ReactNode;
  header?: ReactNode;
}

const classNames = () =>
  makeClassNames({
    root: 'outlined-card',
    footer: 'outlined-card__footer',
    header: 'outlined-card__header',
  });

const OutlinedCard = ({ children, footer, header }: IOutlinedCard) => {
  const cn = classNames();

  return (
    <div className={cn.root}>
      {header && <div className={cn.header}>{header}</div>}
      {children}
      {footer && <div className={cn.footer}>{footer}</div>}
    </div>
  );
};

export default OutlinedCard;
